import { del, get, post, patch } from '../libs/requestClient';
export const fetchAllStaff = () => get('/v1/staff');
export const fetchStaffByID = (id) => get('/v1/staff');
export const createStaff = (data) => post('/v1/staff', data);
